import { computed, observable, action } from 'mobx';

/**
 * Базовы класс транспорта для взаимодействия клиенат и сервера
 */
export default class Transport {
	/**
	 * Признак подключенности транспорта к серверу
	 */
	@observable isConnected = false;

	/**
	 * Количество выполняемых запросов на сервер в текущий момент
	 */
	@observable _pendingRequestCount = 0;

	/**
	 * Адрес сервера
	 */
	_url;

	/**
	 * Создание API транспорта для общения с сервером по REST
	 * @param  {String} url    путь к REST API (default = '/api'), может быть указан как относительный
	 *   путь по отношению к текущему домена, как и полный url вида: http://somedomain.com/api
	 * @param  {Object} socket проинициализированный WebSocket для получения RealTime данных от моделей
	 */
	constructor (url) {
		this._url = url;
	}

	/**
	 * Признак того что транспорт сейчас выполняет запрос
	 */
	@computed get isLoading () {
		return this._pendingRequestCount > 0;
	}

	/**
	 * Вызов метода модели
	 */
	@action async invoke (/* {model, id = null, method, args} */) {
		// реализуется в наследнике
		throw 'Must be implemented in sub class';
	}

	/**
	 * Подключение к серверу
	 */
	@action async connect () {
		// реализуется в наследнике
		throw 'Must be implemented in sub class';
	}

}
